import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './components/style/style.less'
Vue.config.productionTip = false
Vue.prototype.$b64 = require("js-base64").Base64;

Vue.use(ElementUI)
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
